<ul
    class="upload-invoices-options list-group flex-sm-row flex-column flex-wrap justify-content-center align-items-center"
>
    <li *ngFor="let option of options" class="upload-invoices-option list-group-item col">
        <div
            class="upload-invoices-option-tile d-flex justify-content-center align-items-center flex-column text-center"
        >
            <div
                *ngIf="option.isRecommended"
                class="upload-invoices-option-recommended small-uppercase text-center"
                i18n="Indicates that this is the LSQ-recommended method for uploading invoices"
            >
                Recommended
            </div>

            <div class="upload-invoices-option-icon pb-2">
                <lsq-icon [type]="option.icon"></lsq-icon>
            </div>

            <h2 class="py-4">{{ option.title }}</h2>

            <p>{{ option.description }}</p>

            <lsq-button (buttonClick)="select.emit(option)">
                <ng-container i18n="Call-to-action for the user to select this upload method">
                    Select
                </ng-container>
                <span class="sr-only"> {{ option.title }}</span>
            </lsq-button>
        </div>
    </li>
</ul>
